import { vTooltip } from "~/directives/v-tooltip";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', vTooltip);
});
